jQuery(function ($) {
    $(document).ready(function () {
       
    });
});